module.exports = __webpack_public_path__ + "img/Rectangle 21.4e2549f1.png";